export default {
  title: 'FII工业富联',
  menu: {
    homePage: '看板',
    user: '个人中心',
    logout: '退出',
    Management_by_objectives: '目标管理',
    controlAndSchedulingManagement: '控排管理',
    controlAndSchedulingGoalsAndAchievement: '控排目标与达成',
    renewableEnergy: 'Replace可再生能源使用情况',
    projectEmissionReduction: '专案减排',
    reduceManagement: '减排管理',
    projectEmissionReductionProgressControl: '专案进度管控',
    basicModule: '基础模块',
    organizationalStructure: '组织架构',
    projectListEnvironmentalProtectionAndEnergyConservation: '专案列表环保节能立项系统',
    carbonInventoryProject: '碳盘查项目',
    carbonInventoryTask: '碳盘查任务',
    certificationReportManagement: '认证报告管理',
    overviewOfProjectStatus: '专案状态总览',
    overviewOfProjectInvestment: '专案投资总览',
    analysisOfReduceAchievements: 'Reduce达成情况分析',
    Goal_Achievement_Status: '控排目标达成情况',
    Management_by_objectives_children: {
      Goal_setting_and_decomposition: '目标设定与分解',
      // Absolute_control_and_scheduling_objectives_and_achievement: '控排目标与达成',
      Absolute_control_and_scheduling_objectives_and_achievement: '控排目标与达成',
      Project_objectives_and_achievement: '专案目标与达成情况',
      Project_emission_reduction_progress_control: '专案减排进度管控',
      Project_emission_reduction_Goal: '专案减排目标',
      reduce_goal: '减排目标',
      // Absolute_control_Goal: '控排目标',
      Absolute_control_Goal: '控排目标',
      control_Goal: '控排目标',
      Reduce_Goal_Achievement_Status: 'Reduce目标与达成情况',
    },
    operate: '运营',
    operate_children: {
      Carbon_butler: '碳管家',
      foxconnProject: '专案列表鸿海系统',
      Project_management: '专案管理',
      Project_management_children: {
        Project_list: '专案列表',
        Effect_evaluation: '效果评估',
      },
      organizational_management: '机构管理',
      account_management: '账号管理',
      Role_management: '角色管理',
      Menu_management: '菜单管理',
      carbon_butler: '碳管家',
      carbon_butler_children: {
        Factor_maintenance: '因子维护',
        Exchange_rate_table: '汇率维护',
        inventory_Task: '盘查任务',
        inventory_Project: '盘查项目',
        approvalCenter: '审批中心',
      },
    },
    workbench: '工作台',
    workbench_children: {
      To_do_list: '待办列表',
      History_notification: '历史通知',
    },
    //碳管家
    CarbonInventory: '碳盘查',
    inventoryProject: '盘查项目',
    inventoryTask: '盘查任务',
    Level1Nav: '一级导航',
    Level2Nav: '二级导航',
    Level3Nav: '三级导航',
    AlarmLog: '告警记录',
    reportDetail: '报告详情',
    backstage: '后台管理',
    personalCenter: '个人中心',
    signOut: '注销登录',
    loginTitle: '欢迎登录',
    login: '登录',
    centerApproval: '审批中心',
    carbonTemplate: '碳盘查模板',
    carbonTemplateReportInventory: '碳盘查模板填报',
    certificate: 'ISO14064证书管理',
  },
  button: {
    // 公共的按钮，placeholder等
    allBtn: {
      search: '搜索',
      screen: '筛选',
      reset: '重置',
      deleteAll: '批量删除',
      edit: '编辑',
      delete: '删除',
      save: '保存',
      more: '更多',
      confirm: '确定',
      sure: '确认',
      cancel: '取消',
      close: '关闭',
      query: '查询',
      yes: '是',
      no: '否',
      set: '设置',
      uploadFile: '上传文件',
      uploadAttachment: '上传附件',
      fileUpload: '文件上传',
      clickUpload: '点击上传',
      exportReport: '导出报告',
      exportAttachment: '导出附件',
      back: '返回',
      addNew: '新增',
      submit: '提交',
      copy: '复制',
      download: '下载',
      upload: '上传',
      downloadTemplate: '下载模板',
      import: '导入',
      bindTemplate: '绑定模板',
      uploadCertificate: '上传证书',
      view: '查看',
    },
    // 许可证按钮
    licenceBtn: {
      title: '许可证列表',
      addLicence: '新增许可证',
    },
    // 监测方式
    detectionMode: {
      title: '监测方式',
    },
  },
  components: {
    multipleYear: {
      selectYearPlaceholder: '请选择年份',
      yearUnit: '年',
      monthUnit: '月',
    },
    fileUpload: {
      uploadTip: '请上传文件',
      uploadTip1: '1. 支持拓展名: 支持',
      uploadTip2: '格式',
      uploadTip3: '文件大小不能超过',
      formatNotSupport: '文件格式不支持',
      deleteFileFail: '删除文件失败, 请重试',
      uploadFail: '上传文件失败, 请重试',
      supportType: '支持的文件类型',
      clickUpload: '点击上传或拖拽文件到这里',
      uploadTip4: '上传第三方核查认证证书',
      uploadLimit: '上传文件数量不能超过',
      title: '报告名称',
    },
  },
  // 证书管理
  certificate: {
    year: '年份',
    org: '组织',
    accountingBu: '盘查对象',
    showDetail: '查看详情',
    share: '共享',
    certDetail: '证书详情',
    author: '所有者',
    fileSize: '大小',
    previewTip: '该文件格式不支持预览，只支持下载!',
    copySuccess: '已复制链接到剪切板',
    copyFail: '该浏览器不支持自动复制',
  },
  // 登录页
  login: {
    fii_SmartCarbon: 'FII-智慧双碳管理平台',
    fii_SmartCarbon2: '智慧双碳管理平台',
    loop_economy: '循环经济',
    make_green_factory: '减污降碳协同增效 打造绿色灯塔工厂',
    smart_energy: '数智赋能',
    zero_carbon: '深耕清洁技术产品 推动全价值链零碳',
    welcome_login: '欢迎登录',
    account_info: '请输入账号信息',
    password: '请输入密码',
    login_btn: '登录',
    please_input_account: '请输入账号！',
    please_input_password: '请输入密码！',
    network_error: '网络异常，登录失败！',
    get_organize_error: '获取组织权限失败',
    tip: 'Copyright © 2022 工业富联 版权所有 Foxconn Industrial Internet Co.,Ltd.All rights reserved. 粤ICP备17133408号',
  },
  // 待办列表
  todo: {
    To_do_list: '待办列表',
    All: '所有',
    Project_management: '专案管理',
    Carbon_butler: '碳管家',
    Goal_setting_and_decomposition: '目标设定与分解',
    Task: '任务名称',
    Status: '状态',
    CreateTime: '创建时间',
    CreateUser: '创建人',
    Historical_Notifications: '历史通知',
    My_Updates: '我的动态',
    Completed: '已完成',
    Overtime: '超时',
    Common_Entrances: '常用入口',
    Manage: '管理',
    Platform_Dedirection: '平台跳转',
    Smart_Dual_Carbon_Management_Platform: 'FII-智慧双碳管理平台',
    Common_Entrance_Management: '常用入口管理',
    Beyond_Description: '以下超出的应用，添加前请移除',
    Cancel: '取消',
    Confirm: '确定',
    To_do: '待办',
    In_Progress: '进行中',
    Delayed: '已延期',
    Notice: '通知',
    Time: '时间',
    Project_objectives_and_achievement: '专案目标与达成',
    Project_List: '专案列表',
    Up_to_three_commonly_used_entrances: '常用入口最多为3个',
    Please_select_three_commonly_used_entrances: '请选择三个常用入口',
    Update_Success: '更新成功！',
  },
  // 看板
  homePage: {
    Our_Measures: '我们的措施',
    Our_Investment_In_The_Project: '我们在专案的投资',
    Please_Select_The_Legal_Representative: '请选择法人',
    Total_Baseline_Emissions: '基准年排放总量（tCO₂e）',
    Base_Year: '基准年',
    Year_2020: '2020年',
    Range: '范围',
    Inventory_Carbon_Manager: '暂无数据，请在碳管家完成盘查',
    Emission_Reduction_Path_In_The_Past_Five_Years: '我们近五年的减排路径 (tCO₂e)',
    // Absolute_control_and_scheduling_objectives_and_achievement: '控排目标与达成情况',
    Absolute_control_and_scheduling_objectives_and_achievement: '控排目标与达成情况',
    Overview_of_emission_sources: '排放源总览',
    // Absolute_emission_control_target_for_this_year: '今年绝对排控目标',
    Absolute_emission_control_target_for_this_year: '今年排控目标',
    Target_value: '目标值',
    Exceed: '超出',
    Accumulated_actual_emissions: '累计实际排放量',
    // Annual_absolute_control_and_scheduling_goals: '年度控排目标',
    Annual_absolute_control_and_scheduling_goals: '年度控排目标',
    Residue: '剩余',
    Scope_1: '范围1',
    Scope_One: '范围一',
    Scope_2: '范围2',
    Scope_Two: '范围二',
    Scope_3: '范围3',
    // Achievement_status_of_absolute_displacement_control_target: '控排量目标达成情况',
    Achievement_status_of_absolute_displacement_control_target: '控排量目标达成情况',
    Overview_of_Carbon_Emissions: '碳排放总览',
    year: '年',
    month: '月',
    Total_carbon_emissions: '碳排放总量',
    Classification_of_emission_sources: '排放源分类（范围一、范围二）',
    Emission_source_list: '排放源榜单',
    Project_Overview: '专案总览',
    Organization: '组织',
    Planned_carbon_reduction: '规划减碳量',
    Annual_investment_amount: '年投资金额',
    Ten_thousand_yuan: '万元',
    WanKwh: '万kwh',
    License_Announcement: '许可证公告',
    Two_licenses_expired: '本年度有2个许可证到期，请各责任单位注意！',
    Notification_Announcement: '通知公告',
    Risk_classification_control_and_hidden_danger_investigation_and_governance_system: '风险分级管控与隐患排查治理系统',
    Notification_for_online_use: '上线使用的通知',
    Annual_Task_Filling_Notice: '年度任务填报通知',
    Annual_Task_Filling_Notice_Description: '2022年度任务填报工作展开，请各单位及时填报！',
    Annual_total_emissions: '年总排放量',
    Annual_total_emissions2: '年总排放量',
    Emissions: '排放量',
    // Absolute_displacement_control: '控排量',
    Absolute_displacement_control: '控排量',
    reality: '实际',
    target: '目标',
    Accumulated_goals: '累计目标',
    Accumulated_actual: '累计实际',
    January: '1月',
    February: '2月',
    March: '3月',
    April: '4月',
    May: '5月',
    June: '6月',
    July: '7月',
    August: '8月',
    September: '9月',
    October: '10月',
    November: '11月',
    December: '12月',
    steam: '蒸汽',
    electric: '电力',
    heat: '热',
    Fixed_combustion: '固定燃烧',
    Mobile_Burning: '移动燃烧',
    Process_combustion: '制程燃烧',
    Escaping_combustion: '逸散燃烧',
    Request_exception: '请求异常',
    plan: '规划',
    FCE: '固定燃烧排放',
    MCE: '移动燃烧排放',
    // MCEF: '移动燃烧排放-燃料',
    // MCET: '移动燃烧排放-运输',
    PD: '制程排放',
    FE: '逸散排放',
    OE: '外购能源',
    // EDR: '逸散排放制冷剂',
    // TFDW: '逸散排放废水处理',
    power: '外购电力',
    vapour: '外购蒸汽',
    thermalEnergy: '外购热力',
    refrigeration: '外购制冷',
  },
  userInfo: {
    Affiliated_organization: '所属组织',
    user_name: '用户名',
    account: '账号',
    password: '密码',
    Please_enter_your_old_password: '请输入旧密码',
    Please_enter_your_new_password: '请输入新密码',
    Confirm_modifications: '确认修改',
    Change_password: '修改密码',
    role: '角色',
    Modified_successfully: '修改成功！',
    Please_enter_new_password: '请输入新密码！',
  },
  //运营----机构管理
  organizational_management: {
    Organization_Name: '组织名称',
    Please_enter_the_organization_name: '请输入组织名称',
    Search: '查询',
    Reset: '重置',
    Add_organization: '新增组织',
    Batch_Delete: '批量删除',
    Edit: '编辑',
    Delete: '删除',
    Modify_Organization: '修改组织',
    Organizational_code: '组织编码',
    Superior_organization: '上级组织',
    Park: '园区',
    Notes: '备注',
    Delete_Organization: '删除组织',
    Confirm_to_delete_the_organization: '确定删除该组织？',
    Confirm_batch_deletion_of_this_organization: '确定批量删除这些组织？',
    The_organization_name_cannot_have_special_characters: '组织名称中不能含有特殊字符<&,"><=>=<>',
    Organization_Name_Format: '请按照 事业群-TSBG 这种格式填写组织名称',
    Business_group_park_legal_person_BU_building: '事业群园区法人BU楼栋',
    Please_enter_the_organization_code: '请输入组织编码',
    Organization_name_format_no_uppercase_letters: '请按照 bg-tsbg 这种格式填写组织名称, 且不能含有大写字母',
    Please_select_an_organization: '请选择组织',
    Order_number: '序号',
    Operate: '操作',
    Add_successful: '新增成功',
    Edit_successful: '编辑成功',
    Edit_failed: '编辑失败',
    Add_failed: '新增失败',
  },
  // 运营----菜单管理
  menu_management: {
    menu_name: '菜单名称',
    Please_enter_the_menu_name: '请输入菜单名称',
    Select_application: '选择应用',
    Please_select_application: '请选择应用',
    Add_menu: '新增菜单',
    Directory: '目录',
    Menu: '菜单',
    Button: '按钮',
    Edit_menu: '修改菜单',
    Delete_menu: '删除菜单',
    Confirm_to_delete_the_menu: '确定删除该菜单？',
    Add_successful: '新增成功',
    Edit_successful: '编辑成功',
    Delete_successful: '删除成功',
    Edit_failed: '编辑失败',
    Add_failed: '新增失败',
    Delete_failed: '删除失败',
    Menu_type: '菜单类型',
    component: '组件',
    Routing_address: '路由地址',
    Sort: '排序',
    Menu_name: '菜单名',
    Menu_number: '菜单编号',
    Application: '所属应用',
    Please_select_the_application_category: '请选择应用分类',
    Menu_hierarchy: '菜单层级',
    Parent_menu: '父级菜单',
    Please_select_the_parent_menu: '请选择父级菜单',
    Opening_method: '打开方式',
    Inner_chain: '内链',
    Outer_chain: '外链',
    Nothing: '无',
    Redirect: '重定向',
    open_the_homepage_and_load_the_menu: '如需打开主页并加载此目录下的菜单，',
    Please_fill_in_the_loading_menu_route: '请填写加载菜单路由，',
    After_setting: '设置为主页后其他主页设置将被替代',
    Front_end_components: '前端组件',
    Vue_component: '前端vue组件 views文件夹下路径',
    Example: '例',
    The_URL_displayed_by_the_browser: '浏览器显示的URL',
    The_corresponding_open_page: '对应打开页面为菜单页面',
    Permission_identification: '权限标识',
    Weight: '权重',
    System_weight: '系统权重',
    Visible: '是否可见',
    Yes: '是',
    No: '否',
    Please_enter_the_menu_number: '请输入菜单编号',
    Please_select_the_application: '请选择所属应用',
    Please_select_the_menu_level: '请选择菜单层级',
    Please_input_frontend_components: '请输入前端组件',
    Please_input_the_routing_address: '请输入路由地址',
    Please_input_the_permission_identification: '请输入权限标识',
    Please_select_the_weight: '请选择权重',
    Please_select_the_opening_method: '请选择打开方式',
    Top: '顶级',
    Menu_can_be_assigned_to_any_role: '菜单可分配给任何角色，',
    Business_weight: '业务权重',
    Menu_visibility: '菜单对超级管理员不可见',
    When_the_menu_is_selected_to_be_the_homepage: '当选择了需要内链或外链打开的选项，',
    Please_fill_in_the_link: '此处输入要打开的链接地址，',
  },
  // 运营  -- 角色管理
  role_management: {
    Role_name: '角色名',
    Please_enter_the_role_name: '请输入角色名',
    Role_number: '角色编号',
    Please_enter_the_role_number: '请输入角色编号',
    Add_role: '新增角色',
    Edit_role: '修改角色',
    Delete_role: '删除角色',
    More: '更多',
    Authorization_menu: '授权菜单',
    Authorization_data: '授权数据',
    Confirm_to_delete_the_role: '确定删除该角色？',
    Menu_authority: '菜单权限',
    Authorization_scope: '授权范围',
    Please_select_authorization_scope: '请选择授权范围',
    Select_organization: '选择机构',
    Index: '序号',
    Add_successful: '新增成功',
    Edit_successful: '编辑成功',
    Edit_failed: '编辑失败',
    Add_failed: '新增失败',
    Delete_successful: '删除成功',
    Delete_failed: '删除失败',
    Authorization_successful: '授权成功',
    Authorization_failed: '授权失败',
  },
  // 运营 --账号管理
  account_management: {
    normal: '正常',
    Deactivate: '停用',
    Keyword: '关键词',
    Please_enter_the_keyword: '请输入姓名，账号，手机号',
    Status: '状态',
    Please_select_the_status: '请选择状态',
    Search: '查询',
    Reset: '重置',
    Add_user: '新增用户',
    Batch_Delete: '批量删除',
    Edit: '编辑',
    More: '更多',
    Reset_password: '重置密码',
    Authorization_role: '授权角色',
    Authorization_data: '授权数据',
    Delete: '删除',
    Modify_user: '修改用户',
    Job_number: '工号',
    User_name: '姓名',
    Password: '密码',
    Re_password: '重复密码',
    Organization: '组织',
    Organization_name: '组织名称',
    Position: '职位信息',
    // Please_select_the_position: '请选择职位信息',
    Email: '邮箱',
    Phone: '手机号',
    Telephone: '电话',
    Cancel: '取消',
    Confirm: '确定',
    Delete_user: '删除用户',
    Confirm_to_delete_the_user: '确定删除该用户？',
    Confirm_batch_deletion_of_users: '确定批量删除这些用户？',
    Select_organization: '选择组织',
    Please_enter_the_password: '请输入密码',
    Password_format: '密码需含有字母、特殊字符、大小写、8-14个字符',
    Please_enter_the_password_again: '请再次输入密码',
    The_two_passwords_are_inconsistent: '与初设密码不一致',
    Please_enter_the_email: '请输入邮箱',
    Email_format_error: '邮箱格式不正确',
    Please_enter_the_phone: '请输入手机号',
    Phone_format_error: '手机号格式不正确',
    Please_enter_the_name: '请输入姓名',
    Please_enter_the_job_number: '请输入工号',
    Please_select_the_organization: '请选择组织',
    Please_select_the_position: '请选择职位',
    Index: '序号',
    Landline: '座机',
    Operation: '操作',
    Role_Name: '角色名称',
    Unique_Code: '唯一编码',
    Add_successful: '新增成功',
    Edit_successful: '编辑成功',
    Edit_failed: '编辑失败',
    Add_failed: '新增失败',
    Delete_successful: '删除成功',
    Delete_failed: '删除失败',
    Confirm_to_reset_the_password: '确定重置该账号密码？',
    // Reset_password: '重置密码',
    Reset_successful: '重置成功',
    Reset_failed: '重置失败',
    Authorization_successful: '授权成功',
    Authorization_failed: '授权失败',
  },
  project_list: {
    Project_list: '专案列表',
    Project_name: '专案名称',
    Please_enter_the_project_name: '输入专案名称',
    Enter_the_project_name: '请输入专案名称',
    Search: '搜索',
    Empty: '清空',
    Business_group: '事业群',
    Please_select_business_group: '请选择事业群',
    Park: '园区',
    Please_select_the_park: '请选择园区',
    Project_type: '项目类型',
    Please_select_the_project_type: '请选择项目类型',
    Energy_saving_technology: '节能技术',
    Please_select_the_energy_saving_technology: '请选择节能技术',
    Energy_saving_object: '节能对象',
    Please_select_the_energy_saving_object: '请选择节能对象',
    Responsible_person: '责任人',
    Please_enter_the_responsible_person: '请输入责任人',
    Legal_person: '法人',
    Please_select_the_legal_person: '请选择法人',
    Estimated_start_time: '预计开始时间',
    Actual_start_time: '开始时间',
    Estimated_end_time: '预计结束时间',
    Actual_end_time: '结束时间',
    New_project: '新建专案',
    Fii_audit: 'Fii审核',
    No_need_to_add_Fii_audit: '无需添加Fii审核人',
    Please_select_Fii: '请选择Fii',
    View_status: '查看状态',
    Delete: '删除',
    Draft: '草稿',
    Status_change: '状态变更',
    Confirm: '确定',
    Confirm_and_submit: '确定并提交审核',
    From: '从',
    To: '到',
    Acceptance_time: '验收时间',
    Click_upload_attachment: '点击上传附件',
    Opinion: '意见',
    Please_enter_the_opinion: '请输入签核意见（如有）',
    Current_approval_status: '当前审批状态',
    Reject: '驳回',
    Pass: '通过',
    Basic_information: '基础信息',
    Originator: '发起人',
    Name: '姓名',
    Contact: '联系方式',
    Landline_or_phone: '座机/手机',
    Email: '邮箱',
    Create_time: '创建时间',
    Energy_saving_status: '用能现状及问题描述',
    Condition_and_description: '状况及描述',
    Project_information: '项目信息',
    Energy_type: '能源类型',
    Please_select_the_energy_type: '请选择能源类型',
    Energy_source: '技术来源',
    Please_select_the_energy_source: '请选择技术来源',
    Implementation_position: '实施位置',
    Please_select_the_BU: '请选择BU',
    Energy_saving_principle: '节能原理及措施',
    Principles_and_Measures: '原理及措施',
    Effect_evaluation: '效果评估',
    Energy_saving_improvement_year: '改善前能耗/年',
    Energy_saving_improvement: '改善前年耗',
    Energy_saving_improvement_after_year: '改善后能耗/年',
    Energy_saving_improvement_after: '改善后年耗',
    Unit: '单位',
    Amount_of_energy_saving: '节能量',
    Automatic_calculation: '自动计算',
    Emission_factors: '排放因子',
    Please_enter_the_emission_factor: '请输入以t为单位的排放因子',
    Annual_emission_reduction: '年减碳量',
    Please_enter_the_annual_emission_reduction: '请输入计划减碳量',
    Investment: '投资金额',
    Please_enter_the_investment: '请输入金额',
    Energy_price_local: '当地能源单价',
    Energy_price: '能源单价',
    Carbon_intensity: '减碳性价比',
    Automatic: '自动生成',
    Annual_investment_effect: '年投资效益',
    Investment_return: '投资回报期',
    Benefit_analysis: '效益分析',
    Review_nodes: '审核节点',
    Supervisor_review: '主管审核',
    Please_select_the_supervisor: '请选择审核主管',
    Business_group_review: '事业群审核',
    Please_select_the_business_group_review: '请选择审核事业群',
    Status: '状态',
    Draft_status: '处于草稿状态无法上传立项材料',
    Approval_opinion: '签核意见',
    Cancel: '取消',
    Save_draft: '保存草稿',
    Update: '更新',
    Pass_examine: '审核通过',
    Electricity: '电',
    water: '水',
    Steam: '汽',
    Gas: '气',
    Warm: '暖',
    Other: '其他',
    Own_technology: '自有技术',
    External_technology: '外部技术',
    Project_approved: '已立项',
    Procurement_completed: '采购完成',
    Implementation_completed: '实施完成',
    Acceptance_completed: '验收完成',
    Supervisor_review_completed: '主管审核完成',
    Business_group_review_completed: '事业群审核完成',
    Fii_review_completed: 'Fii审核完成',
    Fii_conducted_first: '经济效益>=10万的,必须要先Fii审核!',
    Closing_items: '结项',
    submit_supervisor_review: '确定提交主管审核？',
    Submit_for_review: '提交审核',
    Success: '成功!',
    Request_exception: '请求异常',
    Attachment_is_being_uploaded: '附件上传中，请稍后',
    Special_details: '专项详情',
    Energy_consumption_before_improvement_cannot_be_empty: '改善前能耗不能为空',
    Energy_consumption_before_improvement: '改善前能耗不能（小于） 改善后能耗',
    Energy_consumption_after_improvement_cannot_be_empty: '改善后能耗不能为空',
    Energy_consumption_after_improvement: '改善后能耗不能（大于） 改善前能耗',
    The_initiator_cannot_be_empty: '发起人不能为空',
    Contact_information_cannot_be_empty: '联系方式不能为空',
    Email_cannot_be_empty: '电子邮箱不能为空',
    Business_group_cannot_be_empty: '事业群不能为空',
    Park_cannot_be_empty: '园区不能为空',
    Project_name_cannot_be_empty: '专案名称不能为空',
    Estimated_start_time_cannot_be_empty: '预计开始时间不能为空',
    Estimated_end_time_cannot_be_empty: '预计结束时间不能为空',
    Project_type_cannot_be_empty: '项目类型不能为空',
    Energy_saving_object_cannot_be_empty: '节能对象不能为空',
    Energy_saving_technology_cannot_be_empty: '节能技术不能为空',
    Energy_type_cannot_be_empty: '能源类型不能为空',
    Technical_source_cannot_be_empty: '技术来源不能为空',
    Responsible_person_cannot_be_empty: '责任人不能为空',
    Energy_saving_principle_and_measure: '节能原理及措施不能为空',
    Annual_emission_reduction_cannot_be_empty: '年减碳量不能为空',
    Emission_factor_cannot_be_empty: '排放因子不能为空',
    Investment_amount_cannot_be_empty: '投资金额不能为空',
    Energy_price_local_cannot_be_empty: '当地能源单价不能为空',
    Benefit_analysis_cannot_be_empty: '效益分析不能为空',
    Supervisor_review_cannot_be_empty: '主管审核不能为空',
    Business_group_review_cannot_be_empty: '事业群审核不能为空',
    Please_upload_the_project_proposal: '请上传立项文件！',
    Please_wait_for_loading: '请求加载中请稍后！',
    Project_deleted: '专案已删除',
    File_upload_successful: '上传文件成功',
    File_upload_failed: '上传文件失败',
    Please_select_the_acceptance_time: '请选择验收时间',
    Project_status_changed_successfully: '专案状态变更成功',
    Status_changing: '状态变更中，请稍后',
    End_time_must_be_greater_than_start_time: '结束时间不能小于开始时间!',
    Prompt: '提示',
    Compressed_files_not_support_preview: '压缩文件不支持预览，只支持下载！',
    Doc_files_not_support_preview: 'doc文件不支持预览, 只支持下载！',
    Project_approval: '立项',
    Update_project_success: '更新专案成功!',
    Add_project_success: '新增专案成功!',
    Confirm_delete: '确定删除',
    No_revert: '将无法恢复',
  },
  Project_emission_reduction_progress_control: {
    Start_date: '开始日期',
    End_date: '结束日期',
    Select_date: '选择日期',
    Measures: '我们的措施',
    Overview: '专案总览',
    Organization: '组织',
    Planned_carbon_reduction: '规划减碳量',
    Special_project_emission_reduction_indicators: '专案减排指标',
    Responsible_person: '责任人',
    Number_of_items: '件专案',
    Special_project: '专案',
    Number_of_planned_special_projects: '规划专案数量',
    Number_of_completed: '完成数量',
    Completion_progress: '完成进度',
    Planned_carbon_reduction_unit: '规划减碳量 tCO₂e',
    Actual_carbon_reduction_unit: '实际减碳量 tCO₂e',
  },
  project_objective: {
    Our_Investment_In_The_Project: '我们在专案的投资',
    Annual_Investment_Amount: '年投资金额',
    Acceptance_review_completed_project: '验收审核完成专案',
    All_projects: '所有专案',
    Completed_projects: '完成专案',
    Project_energy_saving: '立项的节能量',
    Actual_energy_saving: '实际节能量',
    Project_status: '专案状态',
    Number_of_projects: '专案数量',
    Energy_saving: '节能量',
    Monthly_target: '月度目标',
    Monthly_target2: '月度实际',
    Monthly_target3: '月度累计目标',
    Monthly_target4: '月度累计实际',
    Plan: '规划',
    Actual: '实际',
    Project_Approval: '立项',
    Procure: '采购',
    Implementation: '实施',
    Acceptance: '验收',
    Supervisor_review: '主管审核',
    Business_Group_Review: '事业群审核',
    Fii_Review: 'Fii审核',
    Closing: '结项',
    Apply: '申请人发起申请',
    Department: '部门审核主管',
    Department_Approval: '部门核准主管',
    Park: '园区及事业群节能干事审核',
    Park_Approval: '节能减排审核主管',
    Park_Manager: '节能减排核准主管',
    Central_Energy_Saving: '中央节能减排承办',
    Central_Energy_Saving_Approval: '中央节能减排审核主管',
    Central_Energy_Saving_Manager: '中央节能减排核准',
    Project_Approval_Completed: '立项申请签核完成',
    Start: '发起验收申请',
    Central_Approval_Completed: '中央核准主管签核验收完',
  },
  Reduce_Goal_Achievement_Status: {
    All_parks: '所有园区',
    Please_select: '请选择',
    Export: '导出',
    Achievement_Status_png: '达成情况图表',
    Achievement_Status_xls: '达成详情',
    by_time: '按时间',
    By_organization: '按组织',
    Reduce_Goal: 'Reduce达成情况',
    Actual_cumulative: '实际累计',
    MonthlyRate: '月度达成率',
    AnnualRate: '年度达成率',
    Target_cumulative: '目标累计',
    Annual_target_reduce: '年度减排目标',
    Achievement: '达标',
    Exceed: '超出',
    Energy_saving: '节能量',
    Energy_saving_one: '节',
    Energy_saving_two: '能',
    Energy_saving_three: '量',
    Achievement_rate: '达成率',
    Achievement_rate_one: '达',
    Achievement_rate_two: '成',
    Achievement_rate_three: '率',
    Annual_target: '年度目标',
  },
  Absolute_control_and_scheduling_objectives_and_achievement: {
    // Absolute_control_this_year: '今年控排目标',
    Absolute_control_this_year: '今年控排目标',
    Actual_cumulative: '累计实际排放量',
    // Annual_target: '年度控排目标',
    Annual_target: '年度控排目标',
    // Achievement: '控排量目标达成',
    Achievement: '控排量目标达成',
    View: '查看',
    time: '时间',
    Park_name: '园区名称',
    Last_update: '上次更新时间',
    // Achievement_status: '绝对排控目标达成情况',
    Achievement_status: '排控目标达成情况',
    Park_achievement_status: '各园区目标与达成情况',
    // Cumulative_absolute_control: '累计控排目标',
    Cumulative_absolute_control: '累计控排目标',
    Standard: '达标情况',
    Last_statistics_time: '上次统计时间',
    Carbon_Butler: '碳管家正在更新！',
  },
  Absolute_control_Goal2: {
    satusDesc1: '达标',
    satusDesc2: '不达标',
    satusDesc3: '数据未上报',
    message1: '导出',
    message2: '选择导出内容',
    message3: '导出当前筛选数据',
    message4: '导出图表',
    message5: '控排目标导出表单',
    message6: '切换视图',
    message7: '立项时间',
    message8: '最后审核时间',
    message9: '阶段',
    空调系统: '空调系统',
    空压系统: '空压系统',
    照明系统: '照明系统',
    环保系统: '环保系统',
    供暖系统: '供暖系统',
    供汽系统: '供汽系统',
    生产系统: '生产系统',
    工业同分: '工业同分',
    配电系统: '配电系统',
    管理系统: '管理系统',
    其他设备: '其他设备',
    电力交易: '电力交易',
    month: '月份',
    metrics: '指标',
  },
  Project_emission_reduction_Goal: {
    Confirm_to_delete: '确定要删除这条数据吗？',
    Set_time: '设置时间',
    Project_target: '专案减排量目标',
    Project_reduce: '专案减排量',
    Distribute_target: '分配目标',
    Upload: ' 将文件拖到此处，或点击上传',
    Upload_one: '将文件拖到此处，或',
    Upload_two: '点击上传',
    Support_extension: '支持扩展名',
    Uploading: '上传中',
    Save: '保存',
    Submit: '提交',
    Add: '新增',
    Business_group_not_less_than_Fii: '事业群的专案减排量之和不能小于Fii的专案减排量！',
    Park_not_less_than_Business_group: '园区的专案减排量之和不能小于事业群的专案减排量！',
    Please_fill: '请将数据填写完整！',
    One_business_group_data: '至少填写一条事业群的数据！',
    One_park_data: '至少填写一条园区的数据！',
    Please_fill_Fii: '请将Fii的数据填写完整！',
    Same_organization: '不能给同一个组织设置两个减排目标！',
    Confirm_synchronize_subordinates: '确定提交后，下级同步更新数据',
    Confirm: '确定提交吗？',
    Submitting: '确定提交',
    Submit_success: '提交成功',
    Submit_failed: '提交失败',
    Save_draft: '已保存为草稿',
    Save_failed: '保存失败，',
    Retain_one: '请至少保留一条数据！',
    Decimal_point_cannot_exceed_11: '数值包括小数点不能超过11位',
    Sum_of_1R_2R_3R_cannot_exceed: '1R，2R，3R加起来不得大于总量',
    Sum_of_1R_2R_3R_must_be_equal: '同一个组织的1R，2R，3R加起来需等于总量',
    Download: '下载',
    No_data: '该年度暂未上传任何文件！',
    Distributional_Goals: '分配目标',
    File_upload: '文件上传',
    Sum_of_monthly_reduction_must_be_greater: '月度专案减排量之和不能小于年度专案减排量',
  },
  Absolute_control_Goal: {
    Standard_year: '较基准年',
    // Absolute_control: '控排总量',
    Absolute_control: '控排总量',
    Standard_year_reduction: '较基准年降幅百分比',
    Business_group_not_less_than_Fii: 'Fii的控排总量之和不能小于事业群的控排总量之和！',
    No_data: '未找到对应目标数据！',
    Confirm_to_delete: '删除该数据后，属于该数据后属于其下一级组织的数据也会被全部删除',
    Park_not_less_than_Business_group: '园区的控排总量之和不能大于事业群的控排总量之和！',
    Business_group_not_less_than_Park: '事业群的控排总量之和不能小于园区的控排总量之和！',
    Not_found: '未找到对应目标！',
    All_month_not_less_than_Business_group: '所有月份的控排总量之和不能大于事业群的控排总量之和！',
    Business_group_not_less_than_All_month: '园区的控排总量之和不能小于月份的控排总量之和！',
  },
  // 驾驶舱
  cockpit: {
    R1_Reduction: '1R 节能减排',
    R2_Renew: '2R 可再生能源替换',
    R1_total: '年度减排1R总目标',
    R2_total: '年度减排2R总目标',
    Reach: '达成',
    Not_achieved: '未达成',
    Control_and_emission_control: '控排',
    Reduction: '减排',
    Legal_person: '目标法人数',
    Carbon_panoramic: '碳全景',
    Annual_control_ranking_target: '年度控排总目标',
    Target_completion_rate: '目标达成率',
    Accumulated_control_of_business_groups: '事业群累计控排情况',
    Accumulated_control_of_parks: '法人累计控排情况',
    Monthly_reduction: '专案月度减排情况',
    Actual_energy_consumption: '实际节能量占比情况',
    Total_investment: '投资总金额',
    Total_volume: '总数量',
    Energy_consumption: '节能量',
    Annual_reduction: '年度减排总目标',
    Carbon_reduction: '碳减排',
    Total_planning: '总规划',
    Energy_saving_situation_of_business_groups: '事业群节能量情况',
    Park_energy_consumption: '法人累计减排情况',
    Monthly_control_ranking: '月度控排情况',
    Range12_of_control: '范围一、范围二控排情况',
    Energy_saving_situation: '减排情况',
    Actual_cumulative_reduction: '实际累计降序',
    Target_cumulative_reduction: '超出达成率降序',
    Actual_cumulative: '实际累计量',
    Target_reduction_volume: '目标减碳量',
    Annual_control_ranking: '年度控排总量',
    Energy_saving: '节能总量',
    Details: '详情',
    Estimated_completion_time: '预计完成时间',
    Achievement_rate_of_emission_reduction_targets: '减排目标达成率',
    Accumulated_target_total_amount: '累计目标总量',
    Accumulated_actual_total_amount: '累计实际总量',
    Excess_Rate: '超出率',
  },
  message: {
    addSuccess: '新增成功',
    editSuccess: '编辑成功',
    addFail: '新增失败',
    editFail: '编辑失败',
    deleteSuccess: '删除成功',
    deleteFail: '删除失败',
    submitSuccess: '提交成功',
    fillSuccess: '填写成功',
    fillFail: '填写失败',
    copySuccess: '复制成功',
    saveSuccess: '保存成功',
    saveFail: '保存失败',
    updateSuccess: '更新成功',
    uploadSuccess: '上传成功',
    uploadFail: '上传失败',
    updateFail: '更新失败',
    computeSuccess: '计算成功',
    computeFail: '计算失败',
    submitFail: '提交失败',
    importSuccess: '导入成功',
    exportSuccess: '导出成功',
    exportFail: '导出失败',
    downloadSuccess: '下载成功',
    importFail: '导入失败',
    paramsError: '参数错误',
    exporting: '正在导出报告......',
    downloading: '正在下载',
  },
  //碳管家
  common: {
    add: '新建',
    delete: '删除',
    view: '查看',
    edit: '编辑',
    cancel: '取消',
    close: '关闭',
    sure: '确定',
    search: '搜索',
    submit: '提交',
    export: '导出',
    org: '组织',
    generate: '生成',
    preview: '预览',
    addS: '新增成功！',
    addE: '新增失败！',
    editS: '编辑成功！',
    editE: '编辑失败！',
    deleteS: '删除成功！',
    deleteE: '删除失败！',
    pSelect: '请选择',
    pInput: '请输入',
    submitS: '提交成功！',
    submitE: '提交失败！',
    chinese: '中文',
    english: '英文',
    update: '更新',
    push: '推送',
    withdraw: '撤回',
    updateS: '更新成功！',
    updateE: '更新失败！',
    pushS: '推送成功！',
    pushE: '推送失败！',
    withdrawS: '撤回成功！',
    withdrawE: '撤回失败！',
    changeS: '修改成功！',
    changeE: '修改失败！',
    data: '数据',
    template: '模板',
    templateSelect: '选择模板',
    save: '保存',
    save_success: '保存成功',
    level1: '差',
    level2: '一般',
    level3: '良',
    level4: '优',
    level5: '优+',
    loading: '加载中...',
    checkSelect: '请检查必填项',
    selectOrSearch: '请选择/搜索最匹配的排放因子',
    deleteConfirm: '是否确认删除？',
    tip: '提示',
  },
  tip: {
    tip1: '此项包括小数不能超过10位',
    tip2: '过热蒸汽的温度最高为600℃',
    tip3: '过热蒸汽的温度不能小于0℃',
    tip4: '过热蒸汽的压力最大为30MPa',
    tip5: '过热蒸汽的压力不能小于0.02MPa',
    tip6: '饱和蒸汽的温度最高为373.68℃',
    tip7: '饱和蒸汽的温度不能小于或等于6.98℃',
  },
  three: {
    loading: '加载中',
    type1_title: '采购的商品和服务',
    type1_title1: '类别一：采购的商品和服务',
    type1_title2: '本公司在报告年份购入的产品上游生产的排放',
    type1_choose_question: '您能提供哪种数据？',
    type1_mode1: '购买量',
    type1_message1: '用户可以提供采购产品和服务的实际量，包括但不限于重量、数量、体积等。',
    type1_mode2: '碳排放量',
    type1_message2: '用户能够直接获取到部分所购产品和服务的碳排放量',
    type1_mode3: '支出金额',
    type1_message3:
      '用户无法提供所购产品或服务的实际量，也无法提供相应产品或服务的碳排放量，但能够提供相应产品、服务的支出金额和凭证',
    number_quality: '活动数据',
    carbon_unit: '碳排放量（tCO₂e）',
    correct_level: '仪表校正等级',
    add_continue: '继续添加',
    upload_error: '上传失败',
    upload: '请上传附件',
    type1_tip1: '请选择产品类型/供应商提供的排放因子',
    type1_tip2: '请输入数量/重量',
    type1_tip3: '请选择',
    type1_tip4: '请选择产品类型',
    type1_tip5: '请输入排放总量',
    type1_tip6: '请输入支出金额',
    type1_tip7: '小数点保留后六位数',
    type2_title: '采购的资本品',
    type2_title1: '类别二：采购的资本品',
    type2_title2: '本公司在报告年份购入的固定资产（厂房、土地、设备、车辆等）产生的上游排放',
    type2_mode1: '支出金额',
    type2_message1: '用户可提供采购各类固定资产的支出金额及金额凭证',
    type2_tip1: '请选择固定资产类型/供应商提供的排放因子',
    type2_tip2: '请选择固定资产类型',
    type3_title: '与燃料和能源相关的活动',
    type3_title1: '类别三：与燃料和能源相关的活动',
    type3_title2: '本公司在报告年份购买和消费的燃料和能源的排放（未列入范围一、范围二的部分）',
    type3_mode1: '燃料/热力/电力消耗量',
    type3_message1: '用户能够提供化石燃料、电力、热力的购入量或使用消耗量',
    type3_tip1: '请输入消耗量',
    type4_title: ' 上游运输与配送',
    type4_title1: '类别四：上游运输与配送',
    type4_title2: '本公司购买的产品从一级供应商到公司之间的运输和配送产生的排放',
    type4_mode1: '燃料消耗量',
    type4_message1: '用户能够提供运输时所消耗的燃料类型以及相应燃料消耗量（重量、体积等）',
    type4_mode2: '运输距离与载重量',
    type4_message2: '用户无法获取运输时燃料消耗数据，但能够提供货物运送时载重情况、运输距离、运输方式等数据',
    type4_mode3: '运输费用支出',
    type4_message3:
      '因数据获取困难、安全限制等原因，无法提供运输时详细燃料的消耗和运输距离等数据时，可通过运输费用的支出估算该部分排放',
    type4_tip1: '请选择运输燃油类型',
    type4_tip2: '请输入体积/重量',
    type4_tip3: '请选择运输方式',
    type4_tip4: '请输入数值',
    type4_tip5: '请选择单位',
    transport_weight: '运输重量',
    transport_distance: '运输距离',
    type5_title: '运营过程中产生的废弃物',
    type5_title1: '类别五：运营过程中产生的废弃物',
    type5_title2: '本公司在报告年份的运营活动产生的废弃物，并交由第三方处理产生的排放',
    type5_mode1: '废物处理量',
    type5_message1: '用户可提供各废弃物类型（纸板、废物、废水等）、重量、处理方法（焚烧、填埋、回收利用、堆肥等）信息',
    type5_mode2: '废物处理支出',
    type5_message2: '若用户无法获取废物处理的详细信息，但可提供因废弃物处理支出的费用 ，可采用该法计算碳排放',
    type5_tip1: '请选择废弃物类型/处理方式',
    type5_tip2: '请输入废弃物重量',
    type6_title: '商务旅行',
    type6_title1: '类别六：商务旅行',
    type6_title2: '因员工外出开展业务而使用第三方交通工具、酒店住宿等产生的碳排放',
    type6_mode1: '出行方式与距离',
    type6_message1: '用户能够提供出行交通方式、出行距离、出行人数等详细数据',
    type6_mode2: '酒店住宿',
    type6_message2: '用户能提供差旅酒店住宿信息，如住宿天数、房间数、人数等',
    type6_mode3: '交通费用支出',
    type6_message3:
      '用户若无法提供详细出行方式，出行距离等信息，但可获取各出行方式的费用，可利用该方法来计算因差旅产生的交通排放',
    numberEmployees: '员工人数',
    travelDistance: '差旅距离',
    people: '人',
    day: '天',
    type6_tip1: '请选择差旅类型',
    type6_tip2: '请输入平均差旅距离/人',
    type6_tip3: '请选择住宿国家',
    type6_tip4: '请输入住宿天数',
    type6_tip5: '请输入员工总差旅距离',
    type7_title: '员工通勤',
    type7_title1: '类别七：员工通勤',
    type7_title2: '因员工从家到工作地点之间的通勤产生的排放',
    type7_mode1: '通勤方式与距离',
    type7_message1: '用户可提供员工日常上班通勤方式、通勤距离等信息',
    number_commuters: '通勤人数',
    number_commuters_unit: '通勤人数（人）',
    commute_distance: '通勤距离',
    work_day: '工作日',
    work_day_unit: '工作日（天）',
    type7_tip1: '请选择通勤类型',
    type7_tip2: '请输入天数',
    type7_tip3: '每人每天往返平均距离（非单程）',
    type7_tip4: '请输入员工每日总通勤距离',
    type8_title: '上游租赁资产',
    type8_title1: '类别八：上游租赁资产',
    type8_title2: '在报告年度内 ，由于运营公司租赁的资产所产生的排放（未纳入范围1 & 2 的部分）',
    type8_mode1: '租赁费用',
    type8_message1: '若用户无法获取租赁资产运营期间的各能耗情况，可通过租赁费用支出计算该部分排放',
    type8_message2: '用户自主进行过碳盘查，能够提供报告期内相关租赁资产运营的排放数据',
    type8_tip1: '请选择建筑类型',
    type8_tip2: '请输入租赁金额',
    type9_title: '下游运输与配送',
    type9_title1: '类别九：下游运输与配送',
    type9_title2:
      '在公司运营场所仓储，并通过非公司拥有或控制的车辆和设施（且非公司支付费用）运输、配送、分销给终端客户而产生的排放',
    type9_tip1: '请输入货物重量',
    type9_tip2: '请输入距离',
    type9_message1: '用户可直接获取到产品下游运输过程产生的碳排放',
    type10_title: '售出产品的加工',
    type10_title1: '类别十：售出产品的加工',
    type10_title2: '针对公司生产的中间产品，销售到下游，由客户 / 第三方进一步加工产生的排放',
    type10_message1: '用户可直接从下游企业处获得相应售出产品加工过程产生的碳排放',
    type11_title: '售出产品的使用',
    type11_title1: '类别十一：售出产品的使用',
    type11_title2: '销售的产品和服务在终端消费者使用过程中产生的排放',
    type11_message1: '用户可直接获得终端消费者使用相应产品产生的碳排放',
    type12_title: '售出产品的最终处理',
    type12_title1: '类别十二：售出产品的最终处理',
    type12_title2: '公司在报告年度出售的产品在其生命周期结束后作为废弃物处置和处理过程的排放',
    type12_message1: '用户能够提供其所售出的产品在生命周期结束后作为废弃物处理时的处理量，处理方式等信息',
    type12_message2: '用户能够提供其所售出的产品在生命周期结束后被报废处置过程中产生的排放',
    type12_tip1: '请选择废弃物类型和处理方法',
    type12_tip2: '产品和包装的总量',
    type13_title: '下游租赁资产',
    type13_title1: '类别十三：下游租赁资产',
    type13_title2:
      '在报告年度，由公司（作为出租方）拥有并出租给其他实体的资产在运营过程中产生的排放（且未纳入范围1&2）',
    type13_mode1: '租赁费用',
    type13_message1: '若用户无法获取租赁资产运营期间的各能耗情况，可通过租赁费用计算该部分排放',
    type13_mode2: '碳排放量',
    type13_message2: '用户自主进行过碳盘查，能够提供报告期内相关租赁资产运营的排放数据',
    type14_title: '特许经营',
    type14_title1: '类别十四：特许经营',
    type14_title2: '未包含在范围1&2的特许经营权的运营排放（即特许权经营方的范围1&2排放），适用于经营权授予方',
    type14_mode1: '基于数量',
    type14_message1: '用户能够提供特许经营方能源使用情况，如：购买使用的电力、热力、化石燃料等情况',
    type14_mode2: '碳排放量',
    type14_message2: '用户可直接从特许经营方获取碳排放量',
    type14_tip1: '请选择租赁资产',
    type15_title: '投资',
    type15_title1: '类别十五：投资',
    type15_title2: '本类别适用于企业投资等金融行为的碳排放计算',
    type15_mode1: '碳排放量',
    type15_message1: '用户所投资的企业有报告自身碳排放的可根据股权投资比例估算该类别碳排放',
    type15_mode2: '被投公司营收',
    type15_message2: '若无法提供被投公司碳排放情况，用户可通过被投公司的营收数据，基于股权比例估算该类别碳排放',
    type15_tip1: '请输入小于100的数值',
    equity_ratio: '股权占比',
    equity_ratio_unit: '股权占比（%）',
  },
  audit: {
    needComments: '请填写审批意见！',
    taskSubmit: '任务提交',
    auditStatus: '审批状态',
    main: '盘查主体',
    deadline: '截止时间',
    submitTime: '提交时间',
    submitM: '提交人',
    approvalStatus: '审批状态',
    approvalDeal: '审批处理',
    agree: '同意',
    reject: '驳回',
    title: '确定并通知审批人',
    approvalMan: '审批人',
    tip: '已提交审批，3s后自动返回到碳盘查任务列表',
    status2: '审批驳回',
    approvalProgress: '审批进度',
    approvalProgressError: '非项目发起人无法查看',
    viewApproval: '查看审批',
    viewProgress: '查看进度',
    taskApproval: '任务审批进度',
    validStatus: '生效状态',
    historyNotice: '历史通知',
    seeMore: '查看更多',
    noticeContent: '通知内容',
    noticeTime: '通知时间',
    carbonInventoryProject: '碳盘查项目',
    projectOverview: '项目概览',
    checkTime: '盘查时间',
    deadlineTime: '截止时间',
    totalNumberOfCommitted: '已提交总数',
    totalNumberOfApprovals: '审批通过总数',
    editCarbonInventory: '编辑碳盘查项目信息',
    errorInfo: '盘查主体无法编辑/提交/审批报告',
    wait: '待审批',
    pending: '审批中',
    pass: '审批通过',
    rejected: '被驳回',
    taskStatus: '任务状态',
    history: '历史记录',
    historyTip: '请选择需要查看任务',
    approvalAdvice: '审批意见',
    rejectTip: '驳回后，将会提交给你继续审批',
    passWord: '通过',
    rejectWord: '请说明驳回原因',
    content0: '审批未提交，请提醒填报人提交',
    content1: '审批中，请等待审批结果',
    content2: '审批完成，无需处理审批',
    content3: '审批已被驳回',
    errorMessage: '异常状态',
    approvalErrorMessage: '请填写审批意见！',
    mySubmit: '我提交的',
    myWaited: '待我审批',
    myHistory: '历史审批',
  },
  project: {
    annual: '年度盘查',
    monthly: '月度盘查',
    special: '客户专项盘查',
    business: '事业群自主盘查',
    government: '政府重点控排企业盘查',
    trading: '碳交易相关盘查',
    other: '其他盘查',
    fillInput: '填写其它内容后自动计算',
    deadLine: '截止日期',
    inventoryDeadLine: '盘查截止日期',
  },
  table: {
    consolidation: '温室气体排放量合并方法',
    range: '范围',
    sort: '序号',
    type: '类别',
    factor: '因子',
    unit: '单位',
    factorValue: '因子值',
    factorUnit: '因子单位',
    dischargeFacility: '排放设施',
    factorSource: '因子来源',
    activeDataQ: '活动数据（质量）',
    activeDataT: '活动数据（温度）',
    activeDataP: '活动数据（压力）',
    greenProject: '温室气体去除项目',
    certified: '认证的CO2减排量',
    dischargeInventory: '排放清单',
    dioxideEquivalent: '数据信息',
    total: '碳排放总量',
    factorValue1: '因子数值',
    activeDataGrade: '活动数据类别（得分）',
    calibrationGrade: '仪器校正类别（得分）',
    gradingStandard: '分级标准',
    level1: '一级（差）',
    level2: '二级（一般）',
    level3: '三级（良）',
    level4: '四级（优）',
    level5: '五级（优+）',
    emissionFactorName: '排放因子名称',
    emissionFactorValue: '排放因子数值',
    emissionfactorGrade: '排放因子类别（得分）',
    emissionfactorSource: '排放因子来源',
    removalVolume: '清除量',
    activityAttachment: '活动数据附件',
    fileTip: '温室气体排放源的说明，重要间接温室气体排放的准则，计算过程使用的全球升温潜能值GWP及其来源',
    file1: '附件1.pdf',
    file2: '附件2.pdf',
    score: '分值',
    score1: '分值<2.0',
    score2: '3.0>分值≥2.0',
    score3: '4.0>分值≥3.0',
    score4: '5.0>分值≥4.0',
    score5: '分值≥5.0',
    rangeTip1: '范围一',
    rangeTip2: '范围二',
    rangeTip3: '范围三',
    rangeTip31: '范围三：组织使用产品/服务间接温室气体排放',
    rangeTip32: '范围三: 产品使用和报废间接温室气体排放',
    rangeTip33: '其它间接温室气体排放',
    domesticSewage: '生活污水',
    industrialWastewater: '工业废水',
    refrigerant: '制冷剂',
    level: '等级',
    name: '姓名',
    jobNumber: '工号',
    authority: '权限',
    organization: '所属组织',
  },
  symbol: {
    leftBracket: '（',
    rightBracket: '）',
  },
  task: {
    selected: '已选',
    clear: '清空',
    canSelectApprover: '可指定的审批节点',
    'organization-direct': '组织层 — 直属主管',
    'organization-high': '组织层 — 高阶主管',
    businessGroup: '事业群层 — 相关责任人',
    CentralGroup: '集团中央层 — 相关责任人',
    'select-approver': '指定后续审批节点参与人',
    searchNameOrCode: '搜索工号/姓名',
    selectOneApprover: '选择审批人（单选）',
    selectApprover: '请选择审批人',
    noneTip: '您已选择无，请先取消！',
    none: '无',
    involove: '我参与的',
    start: '我发起的',
    downloadFile: '下载附件',
    projectApl: '项目审批',
    approval: '如果任务需要审批，请勾选',
    projectMessge: '项目信息',
    buttonTip: '我确认未填报为未发生项目',
    tip: '您填报情况如下，蓝色为已完成填报项目，灰色为未填报项目，请核查确认填报内容',
    greenReason: '请说明免除量化该项温室气体的理由',
    importReason1: '请详述理由，如: 排放预估占全组织总体排放量高于10%',
    importReason2: '请详述理由，如: 组织通过原始数据或刺激数据进行量化',
    importReason3: '请详述理由，如: 不涉及公司及上下游相关方核心机密',
    importReason4: '请详述理由，如: 相关方指定及法律法规规定纳入的间接温室气体',
    importReason5: '请具体说明其它准则',
    PSGreen: '请选择温室气体免除项目',
    PDImport: '请定义和解释重要间接排放标准',
    notSubmit: '暂未提交报告',
    jpName: '法人名称',
    countryOrArea: '所在国家或地区',
    addressRegistration: '注册地址',
    boundary: '盘查边界',
    boundaryInput: '请输入盘查的厂区或楼栋或产线等详细信息',
    factory: '厂区',
    report: '报告',
    title: '碳盘查任务列表',
    title1: '碳盘查项目列表',
    quickInventory: '快速盘查',
    complianceInventory: '合规盘查',
    quickTip: '（我想例行盘查获得数据）',
    complianceTip: '（我想获得完整的温室气体核算报告）',
    inventoryWay: '盘查方式',
    name: '任务名称',
    subordinate: '下级任务名称',
    projectName: '项目名称',
    main: '盘查项目主体',
    progress: '填报进度',
    period: '盘查时段',
    startTime: '开始时间',
    endTime: '结束时间',
    objectName: '盘查对象名称',
    organizationalBoundary: '组织边界',
    operatingBoundary: '运营边界',
    timeStart: '发起时间',
    tips: '请输入内容 如：',
    tips1: '请输入内容 如：Google',
    tips2: '请输入厂区',
    export: '导出数据',
    generate: '生成报告',
    previewReport: '预览报告',
    activeData: '活动数据',
    totalCarbon: '碳排放总量',
    template: '报告模板',
    reportName: '报告名称',
    carbon: '碳排放量（tCO₂e）',
    greenProject: '温室气体免除项目',
    imProject: '重要间接温室气体排放',
    reason: '理由',
    over: '不能超过50字',
    radio1: '股权分配法：按照运营操作所占有的股权份额，相应的承担温室气体排放和能源消耗责任',
    radio2:
      '运营控制法：如果一家公司或其子公司有提出和执行一项业务的运营政策的完全权力，这家公司便对这项业务享有运营控制权',
    radio3:
      '财务控制法：如果一家公司对其业务有财务控制权，那么这家公司能够直接影响其财务和运营政策，并从其活动中获取经济利益',
    closeTip: '直接关闭不会保存修改内容，确定要关闭吗？',
    rangeTime: '盘查时间段',
    taskSource: '任务来源',
    fillData: '填报数据',
    object: '盘查对象',
    legalPerson: '发起法人',
    initiator: '发起人',
    inventoryReport: '盘查报告',
    startFilling: '开始填报',
    continueFilling: '继续填报',
    addTask: '新建盘查任务',
    editTask: '编辑盘查任务',
    beginTask: '开始盘查任务',
    addProject: '新建盘查项目',
    editProject: '编辑盘查项目',
    success: '创建成功',
    viewReport: '查看报告',
    submitted: '已提交',
    notSubmitted: '未提交',
    checkTip1: '范围二：能源间接温室气体排放',
    checkTip2: '范围三：运输产生的间接温室气体排放',
    checkTip3: '范围三：组织使用产品或服务间接温室气体排放',
    checkTip4: '范围三：产品使用和报废间接温室气体排放',
    checkTip5: '范围三：未涵盖的其他间接温室气体排放',
    checkTip6: '排放量的大小',
    checkTip7: '数据获取难易程度和准确性',
    checkTip8: '组织和检测的复杂性',
    checkTip9: '其它相关要求',
    checkTip10: '其它准则',
    checkTip11: '直接温室气体排放和移除',
    checkTip12: '输入能源的间接温室气体排放',
    checkTip14: '燃料与能源相关活动(未计算在范围一、二)',
    checkTip15: '运输产生的间接温室气体排放',
    checkTip16: '组织使用产品或服务间接温室气体排放',
    checkTip17: '与使用产品相关的间接温室气体排放',
    checkTip18: '未涵盖的其他间接温室气体排放',
    PCarbonWay: '请选择盘查方式',
    PTask: '请输入任务名称',
    PObject: '请输入盘查对象名称',
    PTime: '请选择盘查时段',
    PProject: '请选择温室气体免除项目',
    PIndirect: '请选择重要间接温室气体排放',
    PPurpose: '请输入盘查目的',
    PBoundary: '请选择组织边界',
    PReason: '请输入理由',
    PInput: '请输入',
    PReport: '请生成报告',
    PProjectName: '请选择项目名称',
    inputProjectName: '请输入项目名称',
    POrg: '请选择组织',
    PDelete: '请选择要删除的数据！',
    colon: '：',
    comma: '，',
    fullStop: '。',
    delete1: '确定删除',
    delete2: '这些项目吗？',
  },
  detail: {
    download: '一键下载',
    purpose: '盘查目的',
    orgBoundary: '组织边界',
    users: '报告预期使用方',
    reportBoundary: '报告边界',
    reportOrg: '报告组织',
    reportStandard: '报告标准',
    time: '时间边界',
    pass: '是否通过边界',
    basicMessage: '一、基本信息',
    emissionDistribution: '二、排放分布情况',
    detailedList: '三、碳排放详细清单',
    dataSource: '四、活动数据及来源',
    dataQuality: '五、数据质量评估',
    emissionFactor: '六、排放因子数据及来源',
    removalProject: '七、温室气体去除项目',
    qualityLevel: '八、质量等级',
    dataAttachment: '九、活动数据附件',
    dataAttachment1: '八、活动数据附件',
    otherMessage: '十、其他相关信息',
    otherMessage1: '九、其他相关信息',
    enterprise: '企业信息',
    orgMessge: '组织本身、监管机构',
    attachments: '见附件1',
    standard: '符合IS014064标准',
    dataVerification: '数据经过内部核验',
    totalEmission: '总排放（tCO₂e）',
    rangeTotal1: '范围一总量',
    rangeTotal2: '范围二总量',
    rangeTotal3: '范围三总量',
    biomass: '生物质燃烧',
    gradeTip1:
      '评估方法:按照活动数据分类的赋值、排放因子分类的赋值和仪器校正分类的赋值计算出平均值，再乘以各排放源百分比，然后进行加总得到总体不确定性评分。',
    gradeTip2: '数据级别分成五级，级别愈高，数据品质质量愈好。经计算此次核查的数据质量得分为：',
    gradeTip3: '等级为',
  },
  report: {
    greenType: '绿证类型',
    energyType: '能源类型',
    certName: '证书名称',
    Pelectricity: '选择抵扣外购电力',
    automatic: '自动计算',
    actualUse: '实际用量',
    actualUnit: '实际单位',
    unitiveUse: '统一后单位用量',
    unitiveUnit: '统一后单位',
    offsetInput: '填写排放源、因子版本、地区、绿电用量可计算',
    changeOld: '更换为历史版本',
    nonGreen: '非绿电用量',
    greenEle: '绿电用量',
    totalEle: '用电总量',
    staging: '暂存',
    cooperation: '协作',
    upload: '上传附件',
    preview: '预览',
    type: '排放源',
    type2: '排放源(英文)',
    factorUnit: '因子单位',
    version: '因子版本',
    carbon: '碳排放量（tCO₂e）',
    file: '附件',
    region: '地区',
    region1: '国家/地区BOD生活废水中BOD值',
    industry: '行业',
    dischargeFacility: '排放设施',
    activeData: '活动数据',
    activeDataInput: '根据废水量、COD自动计算得出',
    activeDataInput1: '根据人数、BOD地区、IPCC缺省值、污水处理天数计算',
    activeDataType: '活动数据类型',
    activeDataQuality: '活动数据类型',
    calibrationLevel: '仪表校正等级',
    number: '人数（人）',
    productType: '产品类型',
    productVolume: '工业产品总量',
    wasteWater: '废水量m³',
    inputOxygen: '进口废水中的化学需氧量浓度',
    outputOxygen: '出口废水中的化学需氧量浓度',
    inputOxygenP: '厌氧段进口废水中的化学需氧量浓度(mgCOD/L)',
    outputOxygenP: '厌氧段出口废水中的化学需氧量浓度(mgCOD/L)',
    codInput: '根据进/出口废水中的化学需氧量浓度自动计算得出',
    productName: '产品名称',
    sludge: '污泥清除有机物重量(kg)',
    reclaimCH4: '回收的CH4重量(kg)',
    hotWaterQuality: '热水质量',
    hotWaterTemperature: '热水温度',
    steamQuality: '蒸汽质量',
    saturatedSteamQuality: '饱和蒸汽质量',
    press: '压力',
    temperature: '温度',
    factoryIndustry: '工厂行业',
    factoryType: '工厂类型',
    area: '面积（㎡）',
    operatingArea: '经营面积（㎡）',
    rentalCategory: '租赁类别',
    revenueAmount: '收入金额',
    transportType: '运输类型',
    distributionType: '配送类型',
    investmentType: '投资类型',
    investmentIndustry: '投资行业',
    investmentAmount: '投资金额',
    materialType: '材料类型',
    processingIndustry: '加工企业行业',
    processingAmount: '加工金额',
    purchaseType: '购买类型',
    purchasingIndustry: '采购行业',
    emissionType: '排放类型',
    enterpriseProductType: '企业产品类型',
    travelType: '商旅类型',
    weight: '重量（t）',
    amount: '金额',
    expenditure: '废弃物管理开支',
    wasteType: '废弃物类型',
    quantitySold: '售出数量（个）',
    lifeExpectancy: '预期寿命（月）',
    energyUsed: '单个产品所用能源',
    energyUsed1: '单个产品所用能源/月',
    trialEnergy: '产品试用能源',
    useEnergy: '产品使用能源',
    intendedUsed: '产品预计使用地区',
    name: '名称',
    numberEmployees: '员工人数（人）',
    carbonReduction: '减碳量（t)',
    unit: '单位',
    wasteLatitude: '废弃物统计方法',
    spending: '开销',
    quality: '质量',
    pSelect: '请选择内容',
    pInput: '请输入内容',
    pInputWasteWater: '请输入废水总量',
    pNum: '请输入纯数字',
    range1: '范围一',
    range2: '范围二',
    range3: '范围三',
    fixedCombustion: '固定燃烧排放',
    mobileCombustion: '移动燃烧排放',
    processEmissions: '制程排放',
    fugitiveEmissions: '逸散排放',
    fugitiveEmissions1: '逸散排放-生活污水',
    fugitiveEmissions2: '逸散排放-工业废水',
    fugitiveEmissions3: '逸散排放-制冷剂、灭火器',
    electricity: '外购电力',
    heat: '外购热力',
    hotWater: '外购热水',
    heatSteam: '外购过热蒸汽',
    saturatedSteam: '外购饱和蒸汽',
    greenElectricity: '绿电',
    nonGreenElectricity: '非绿电',
    solarEnergy: '自建光伏',
    greenCertificates: '外购绿证',
    offsetEmission: '抵消排放量（tCO₂e）',
    employeeCommuting: '员工通勤',
    tradeCaravan: '商旅',
    biomassCombustion: '生物质燃烧排放',
    upstreamLeased: '上游租赁资产',
    downstreamLeased: '下游租赁资产',
    thirdPartyTransportation: '第三方运输',
    upstreamAndDownstream: '上下游配送',
    wasteOperations: '运营产生的废弃物',
    processingProducts: '售出产品的加工',
    useProducts: '售出产品的使用',
    soldProducts: '售出产品的报废处理',
    franchising: '特许经营',
    productsAndServices: '组织采购的产品和服务',
    investment: '投资',
    otherGreenhouseGases: '其它温室气体排放数据',
    greenhouseGasRemoval: '温室气体去除项目',
    tip1: '组织运营当中存在固定设备内部的燃料燃烧，如锅炉/熔炉/涡轮/加热器/焚烧炉/引擎和燃烧塔等',
    tip2: '组织运营当中拥有或租赁了消耗燃料的运输设备并自己经营（如机动车辆/卡车/船舶/飞机/火车头/堆高机）等（不包括上下游的运输）',
    tip3: '组织运营中存在物理或化学的工艺制程，导致排放温室气体，包括但不限于水泥生产过程中煅镁环节产生的二氧化碳，石化工艺中催化裂化产生的二氧化碳、以及炼铝产生的全氟碳化物等',
    tip41: '组织运营当中生活污水处理',
    tip42: '组织运营当中工业污水处理',
    tip43: '组织运营当中制冷剂处理',
    tip5: '组织购买的电力',
    tip6: '组织购买的热力（填入以“GJ”为单位的活动数据）',
    tip7: '组织购买的热水（填入以“t”或“L”为单位的活动数据，后续转为“GJ”单位进行计算）',
    tip8: '组织购买的过热蒸汽（填入以“t”或“L”为单位的活动数据，后续转为“GJ”单位进行计算）',
    tip9: '组织购买的饱和蒸汽',
    tip10: '组织购买的绿电',
    tip11: '组织购买的太阳能',
    tip12:
      '假设厂区的污水处理根据盘查时间段确定， 其他值默认采用IPCC缺省值，MCF默认为厌氧反应堆（0.5），无CH4回收系统和污泥清除的污水处理系统。',
    tip13: '假设Bo最大的CH4产生能力为 0.25kgCH4/COD， 此处无CH4回收系统和污泥清除的污水处理系统',
    tip14: '组织外购的绿证证书，用于抵消范围二的碳排放量',
    totalCarbon: '碳排放数据总量',
    have: '有',
    not: '无',
    fileName: '附件名称',
    electricQuantity: '电量（kWh）',
    emissionReduction: '减排量',
    onlyPDF: '附件大小限制 50M 以内',
    unitCalculator: '单位计算器',
    beforeConversion: '转换前',
    conversionRatio: '转换系数',
    afterConversion: '转换后',
    ISOMessage1: '直接温室气体排放(类别1)',
    ISOMessage2: '化石燃料燃烧产生的的温室气体排放',
    ISOMessage3: '生物、物理或化学等产生温室气体排放之制程',
    ISOMessage4: '拥有控制权下的原料、产品、废弃物与员工交通等运输',
    ISOMessage5: '逸散性温室气体排放源',
    ISOMessage6: '能源间接温室气体排放(类别 2)',
    ISOMessage7: '来自于外购的电力、热、蒸汽或其他化石燃料衍生能源产生之温室气体排放',
    ISOMessage8: '运输间接温室气体排放(类别 3)',
    ISOMessage9:
      '温室气体的运输间接排放（如：员工商务旅行；经由第三者团体产品、原料或废弃物之运输;员工通勤往来工作场所）',
    ISOMessage10: '使用产品之间接温室气体排放(类别 4)',
    ISOMessage11: '使用产品之间接温室气体排放（如：外援活动、外包制造与授权经销商；包含于非能源原物料的排放）',
    ISOMessage12: '产品之间接温室气体排放(类别 5)',
    ISOMessage13:
      '产品之间接温室气体排放（如：设施产生的产品与服务的使用与生命终期阶段的排放；当温室气体排放点发生在设施边界之外的排放源或设施，其排放来自设施所产出之废弃物）',
    ISOMessage14: '其他间接温室气体排放(类别 6)',
    ISOMessage15: '其他来源的温室气体排放（不包含于以上5个类别内）',
    carbonUnit: '排放量（tCO₂e）',
    percentage: '百分比',
    ISOTable2Message1: '类别1排放量',
    ISOTable2Message2: '类别2排放量',
    ISOTable2Message3: '类别3排放量',
    ISOTable2Message4: '类别4排放量',
    ISOTable2Message5: '类别5排放量',
    ISOTable2Message6: '类别6排放量',
    ISOTable2Message7: '直接温室气体排放量',
    ISOTable2Message8: '能源间接排放量',
    ISOTable2Message9: '运输间接温室气体排放量',
    ISOTable2Message10: '使用产品之间接温室气体排放量',
    ISOTable2Message11: '产品之间接温室气体排放量',
    ISOTable2Message12: '其他间接温室气体排放量',
    ISOTable2Message13: '各类温室气体总排放量',
    ISOTable2Message14: '各类温室气体百分比',
    summary: '汇总',
    ISOMessage16: '加权平均积分数据等级',
    ISOMessage17: '加权平均积分数据',
    activeDataRank: '活动数据等级',
    carbonEmissionRank: '排放系数等级',
    calibrationRank: '仪器校正等级',
    avgScore: '平均得分',
    rank: '数据等级',
    carbonEmissionRate: '排放量占比',
    weightedAvgScore: '加权平均积分',
    total: '总计',
    ratio: '比例',
    information: '说明',
    type1: '类别一',
    type2: '类别二',
    type3: '类别三',
    type4: '类别四',
    type5: '类别五',
    type6: '类别六',
    ghg: 'GHG报告模板',
    ghgReport: 'GHG报告',
    iso: 'ISO14064模板',
    isoReport: 'ISO14064报告',
    reportNo: '报告编号',
    isoTitle1: '一、组织概况',
    isoTitle2: '二、组织边界',
    isoTitle3: '三、运营边界',
    isoTitle4: '四、温室气体量化',
    companyName: '公司名称',
    companyNamePlaceholder: '请输入公司名称',
    companyAddress: '公司地址',
    companyAddressPlaceholder: '请输入公司地址',
    businessScope: '经营范围',
    businessScopePlaceholder: '说明经营范围',
    businessActivity: '主要生产经营活动或主要产品',
    greenhouseGasEmissionSources: '温室气体排放源',
    totalGreenhouseGasEmissions: '温室气体排放总量',
    totalEmissionsOfGreenhouseGasCategories: '温室气体类别排放总量',
    emissionFactorDataAndSources: '排放因子数据及来源',
    dataQualityManagement: '数据质量管理',
    noDataTip: '暂无页面信息',
    discharge0: '其他',
    discharge1: '锅炉',
    discharge2: '涂装设备',
    discharge3: '发电机',
    discharge4: '加热器',
    discharge5: '废气燃烧塔',
    discharge6: '燃气灶(瓦斯炉)',
    discharge7: '燃烧器',
    discharge8: '干燥器',
    discharge9: '焚烧炉',
    discharge10: '烤箱(炉)',
    discharge11: '柴油泵',
    discharge12: '恒温恒湿机',
    discharge13: '公务车 ',
    discharge14: '货车',
    discharge15: '除草机（从固定燃烧调整至移动燃烧）',
    discharge16: '叉车(推高机) ',
    discharge17: '化粪池',
    discharge18: '废水处理',
    discharge19: 'CO2灭火器',
    discharge20: '七氟丙烷灭火器',
    discharge21: '空调',
    discharge22: '冰水机',
    discharge23: '冰箱',
    discharge24: '防/除锈油',
    discharge25: '生产及办公设备设施',
    discharge26: '办公设备设施',
    discharge27: '供暖设备',
    discharge28: '加热设备',
    discharge29: '加湿设备',
  },
  stage: {
    administrator: '管理员',
    normalUser: '普通用户',
    supervisor: '主管',
    pwd: '请输入密码',
    pwdonce: '请再次输入密码',
    notSame: '与初设密码不一致',
    tabTitle1: '组织管理',
    tabTitle2: '用户管理',
    tabTitle3: '因子维护',
    tabTitle4: '汇率维护',
    orgTree: '组织树',
    setRoot: '设置根节点：',
    orgName: '组织名称：',
    orgCode: '组织编码：',
    parentOrg: '上级组织：',
    deleteSure: '确定要删除该条数据吗？',
    inputTip: '请输入内容 如：',
    operation: '操作',
    sort: '排序',
    organization: '所在组织',
    superiorDepartment: '上级部门',
    addOrg: '新增组织',
    editOrg: '编辑组织',
    userName: '用户名',
    jobNumber: '工号',
    account: '账号',
    email: '邮箱',
    mobile: '手机号',
    password: '密码',
    addUser: '新增账号',
    editUser: '编辑账号',
    yourOrg: '所在组织',
    schedule: '基础汇率表',
    currency: '币种',
    rate: '兑换USD汇率',
    dataSource: '数据来源',
    updatedTime: '最后更新时间',
    addC: '新增币种',
    editC: '编辑币种',
    fixedCombustion: '固定燃烧',
    mobileCombustion: '移动燃烧',
    biomassCombustion: '生物质燃烧',
    foundational: '基础因子',
    thirdParty: '第三方运输与配送',
    basicTable: '基础因子表',
    userType: '用户类型',
    changePsd: '修改密码',
    newPsd: '新密码',
    newPsdC: '新密码确认',
    PInputC: '请输入账号',
    PPsd: '请输入密码',
    notNull1: '账号不能为空',
    notNull2: '密码不能为空',
    category1: '因子分类1',
    category2: '因子分类2',
    emissionFactorUnit: '排放因子单位',
    emissionGasUnit: '排放气体单位',
    activeUnit: '活动数据单位',
    factorEn: '因子名称（英文）',
    factorCode: '因子编码',
    country: '国家',
    countryEn: '国家（英文）',
    sectoralEmissions: '分行业排放',
    energy: '能源',
    sOrg: '同步组织',
    sOrgS: '同步成功',
    tableTip:
      '范围三中分类 组织采购的产品和服务，售出产品的加工和投资所使用的因子为全行业排放因子表，售出产品的使用所使用的因子为范围三-能源因子表。',
  },
  // 盘查模板
  template: {
    newTemplate: '新建模板',
    editTemplate: '编辑模板',
    templatePlaceholder: '请输入模板名称',
    templateName: '模板名称',
    templateUsed: '被使用',
    templateSelect: '选择下载模板',
    templateSelectPlaceholder: '请先选择需要下载的模板',
    templateInclude: '模板内容包括',
    templateImport: '已有模板，点击导入',
    templateDownloading: '正在下载模板......',
    importError: '导入失败数据',
    importErrorNum: '数据导入失败条数：',
    importErrorReason: '失败原因：',
    importTitle: '数据导入',
  },
  // 鸿海专案
  honghai: {
    detail: '专案详情',
    approval: '签核详情',
    history: '签核历史表',
    application: '立项申请签核流程',
    acceptance: '项目验收签核流程',
    projectNumber: '立项单号',
    stepActive: '当前进度',
    opinion: '意见',
    pass: '已通过',
    reject: '驳回',
    jobNumber: '工号',
    applicant: '申请人',
    originator: '发起人',
    name: '姓名',
    contact: '联系方式',
    mobile: '联系人手机',
    extension: '分机',
    email: '邮箱',
    group: '事业群',
    selectgroup: '选择事业群',
    legalPerson: '法人',
    selectlegalPerson: '选择法人',
    park: '园区',
    selectpark: '选择园区',
    createTime: '创建时间',
    applyTime: '申请时间',
    greenenergyDescribe: '用绿能现状及问题描述',
    pleaseEnter: '请输入',
    Energy_saving_system: '节能系统',
    Energy_saving_method: '节能方法',
    Energy_saving_object: '节能对象',
    Energy_type: '能源类型',
    Technical_sources: '技术来源',
    Principle: '节能原理',
    Annual_repair_cost: '年维修费用',
    Annual_energy_efficiency: '年节约效益',
    Additional_benefits: '附加效益',
    Total_benefits: '总效益',
    Project_period: '项目周期',
    Project_benefit: '投资效益',
    Basic_information: '基本信息',
    Project_information: '项目信息',
    Benefit_information: '效益信息',
    title: '专案列表-环保节能立项系统',
    search: '输入专案名称、立项单号、验收单号ID',
    collapseFilter: '收起筛选',
    expandFilter: '展开筛选',
    currentStep: '当前审核节点',
    actualStartTime: '实际开始时间',
    actualEndTime: '实际结束时间',
    detailInfo: '签核信息详情',
    actualFinishTime: '实际完成时间',
  },
  // 可再生能源使用情况
  renewableEnergy: {
    title: '可再生能源使用情况',
    AccEleConsumption: '累计电力消耗',
    OverviewEleConsumption: '电力消耗总览',
    eleAndRenew: '市电和可再生能源总和',
    totalRenew: '可再生能源总量',
    totalEleFromOne: '统计1月到本月总量',
    replaceTarget: 'Replace目标达成进度',
    nonRenewable: '非可再生资源',
    AccRenewablePercentage: '可再生能源累计占比',
    renewablePercentage: '可再生能源占比',
    AnnualRenew: '年度可再生能源使用总量',
    yoy: '同比',
    monthOverview: '月度电力消耗总览',
    monthRenew: '本月可再生能源总量',
    monthRenew1: '本月消耗总量',
    currentMonthRenew: '统计本月总量',
    monthConsumption: '月度能源消耗情况',
    monthConsumptionOverview: '统计每个月电力消耗使用情况',
    greenEnergy: '外购绿电',
    solarEnergy: '自建光伏',
    greenCertificate: '外购绿证',
    progress: '进度',
    proportion: '占比',
    nonGreen: '非绿电',
    externalPower: '外购电力',
    renewable: '可再生能源',
    AccConsumpt: '累计消耗 万kwh',
    AccConsumptYoy: '较去年 万kwh',
    Consumpt: '消耗量 万kwh',
    nonRenew1: '非可再生能源',
    Renew1: '可再生能源目标与实际',
    Renew2: '2R月度目标',
  },
  //Reduce投资情况
  reduceInvestment: {
    title: 'Reduce投资情况',
    Reduce_Investment_Status: 'Reduce目标与达成情况',
    Compare_With_Last_Year: '与上年投资情况对比',
    Annual_unit_Project_Expenditure: '各单位年度项目支出',
    Energy_saving_system_investment_cost: '节能系统投资成本表',
    energyTypePer: '能源类型占比',
    energySystemPer: '节能系统占比',
    excel: '减排成本项目表',
    totalInvest: '总投资金额',
    totalBenefit: '总投资效益',
    Annual_Project_Expenditure: '各年度项目支出',
    year: '年份',
    org: '组织',
    investmentDetail: '节能系统投资明细',
    mode: '统计方式',
    byCost: '按投资成本',
    byNum: '按专案数量',
    byEnergy: '按节能量',
    system: '系统',
    object: '节能对象',
    count: '专案总数',
    investmentAmount: '投资总额',
    investbenefit: '投资效益',
    projectReturn: '投资回报期',
    energy: '节能量',
    cost: '投资成本',
  },
};
